<app-base-modal
  [title]="'Журнал изменений'"
  size="large"
>
  <div class="content">
    @for (changelog of changelogs ? Object.values(changelogs) : []; track $index) {
      <div class="content-item">
        <h4>{{ changelog.title }}</h4>
        <pre class="changelog">{{ changelog.content }}</pre>
      </div>
    }
  </div>
  <div class="buttons-container">
    <button
      mat-button
      tabindex="-1"
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
